export default __webpack_public_path__ + "static/media/HEPublicQuestionnaire.fbb06149.xls";